import React, { useState } from "react";

const pricingData = [
  {
    title: "Startup",
    description: "For small businesses. Full package with quick delivery.",
    price: "GH₵ 3,500 (one-time)",
    duration: "Development duration: 10 days",
    features: [
      { name: "1 year FREE hosting + Domain", included: true },
      { name: "Template based design", included: true },
      { name: "Admin panel access", included: false },
      { name: "Webpages developed - 1", included: true },
      { name: "Online chat integration", included: false },
      { name: "On-page SEO", included: false },
      { name: "Web Copy", included: false },
    ],
  },
  {
    title: "Corporate",
    description: "For medium businesses needing a professional online presence.",
    price: "GH₵ 14,000 (one-time)",
    duration: "Development duration: 1–2 months",
    features: [
      { name: "1 year FREE hosting + Domain", included: true },
      { name: "Template based design", included: true },
      { name: "Admin panel access", included: true },
      { name: "Webpages developed - up to 10", included: true },
      { name: "Online chat integration", included: true },
      { name: "On-page SEO", included: true },
      { name: "Web Copy", included: true },
    ],
  },
  {
    title: "Premium",
    description: "For large businesses with custom needs and unlimited pages.",
    price: "GH₵ 25,000+ (starting cost)",
    duration: "Development duration: 2–3 months",
    features: [
      { name: "1 year FREE hosting + Domain", included: true },
      { name: "Custom design and functionality", included: true },
      { name: "Admin panel access", included: true },
      { name: "Webpages developed - Unlimited", included: true },
      { name: "Online chat integration", included: true },
      { name: "On-page SEO", included: true },
      { name: "Web Copy", included: true },
    ],
  },
];

const Pricing = React.forwardRef((props, ref) => {
  const [activeIndex] = useState(1); // Default active plan (Corporate)

  return (
    <section
      ref={ref}
      style={{
        minHeight: "100vh",
        padding: "4rem 2rem",
        background: "linear-gradient(to right, #f0f0f0, #dac5adff)",
      }}
    >
      <h2
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          textAlign: "center",
          color: "#8B4513",
          marginBottom: "3rem",
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
        }}
      >
        Web Development Packages (Ghana)
      </h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "2rem",
        }}
      >
        {pricingData.map((plan, index) => {
          const isActive = index === activeIndex;
          return (
            <div
              key={index}
              style={{
                backgroundColor: isActive ? "#A0522D" : "#fff",
                color: isActive ? "#fff" : "#555",
                padding: "1rem",
                borderRadius: "10px",
                border: "2px solid #A0522D", // brown border
                boxShadow: isActive
                  ? "0 8px 20px rgba(0,0,0,0.3)"
                  : "0 4px 12px rgba(160, 82, 45, 0.3)", // light shadow on border
                maxWidth: "320px",
                textAlign: "center",
                transition: "all 0.3s ease",
                transform: isActive ? "scale(1.05)" : "scale(1)",
              }}
            >
              <h3
                style={{
                  fontWeight: "bold",
                  marginBottom: "0.5rem",
                  color: isActive ? "#fff" : "#8B4513",
                }}
              >
                {plan.title}
              </h3>
              <p style={{ marginBottom: "1rem" }}>{plan.description}</p>
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "1.25rem",
                  color: isActive ? "#fff" : "#A0522D",
                }}
              >
                {plan.price}
              </span>
              <p
                style={{
                  marginTop: "0.5rem",
                  fontStyle: "italic",
                  color: isActive ? "#ffd1a4" : "#666",
                }}
              >
                {plan.duration}
              </p>

              {/* Features */}
              <ul
                style={{
                  listStyle: "none",
                  padding: "1rem 0 0 0",
                  textAlign: "left",
                  marginTop: "1rem",
                }}
              >
                {plan.features.map((feature, i) => (
                  <li
                    key={i}
                    style={{
                      marginBottom: "0.5rem",
                      color: isActive ? "#fff" : "#555",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      fontWeight: 500,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "1rem",
                        color: feature.included
                          ? isActive
                            ? "#fff"
                            : "#28a745" // green check
                          : isActive
                          ? "#ffd1a4"
                          : "#dc3545", // red cross
                      }}
                    >
                      {feature.included ? "✔" : "✖"}
                    </span>
                    {feature.name}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
});

export default Pricing;
